import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { useTranslation } from 'react-i18next'
import { RentalListPage } from '@/components/rental-list-page'

const searchSchema = z.object({
	propertyId: z.string().optional(),
})

export const Route = createFileRoute('/_app/rent/completed')({
	validateSearch: searchSchema,
	component: RentCompletedPage,
})

function RentCompletedPage() {
	const { t } = useTranslation()
	const { propertyId } = Route.useSearch()
	return (
		<RentalListPage
			status="COMPLETED"
			initialPropertyId={propertyId}
			emptyTitle={t('rent.completed.emptyTitle')}
			emptyDescription={t('rent.completed.emptyDescription')}
		/>
	)
}
